import numeral from 'numeral';

export class SubtransactionForm {
  constructor(key) {
    this._key = key;

    this._customerProduct = null;
    this._amount = 0;

    // select model
    this._customerProducts = [];
  }

  get key() {
    return this._key;
  }

  set customerProduct(customerProduct) {
    this._customerProduct = customerProduct;
  }

  get customerProduct() {
    return this._customerProduct;
  }

  set customerProducts(customerProducts) {
    this._customerProducts = customerProducts;
  }

  get customerProducts() {
    return this._customerProducts;
  }

  set amount(amount) {
    this._amount = amount;
  }

  get amount() {
    return this._amount;
  }

  get customerProductSelect() {
    return this._customerProducts;
  }
}

export class TransactionForm {
  constructor(customerProducts) {
    // form fields model
    this._email = null;
    this._paymentOptionType = null;
    this._subTransactionsForm = [];
    this._fee = 0;

    // select model
    this._customerProducts = customerProducts;
    this._selectedCustomerProducts = [];

    // misc
    this.nextItemKey = 0;

    this.addSubtransaction();
  }

  set email(email) {
    this._email = email;
  }

  get email() {
    return this._email;
  }

  set paymentOptionType(paymentOptionType) {
    this._paymentOptionType = paymentOptionType;
  }

  get paymentOptionType() {
    return this._paymentOptionType;
  }

  set subtransactionsForm(subtransactionsForm) {
    this.subtransactionsForm = subtransactionsForm;
  }

  get subtransactionsForm() {
    return this._subTransactionsForm;
  }

  set fee(fee) {
    this._fee = fee;
  }

  get fee() {
    return this._fee;
  }

  get customerProducts() {   
    return this._customerProducts;
  }

  get selectedCustomerProducts() {
    return this._selectedCustomerProducts;
  }

  addSubtransaction() {
    const subtransactionForm = new SubtransactionForm(this.nextItemKey);

    let copy = this.customerProducts.slice(0);
    copy = copy.filter(item => !this.selectedCustomerProducts.includes(item.id));
    subtransactionForm.customerProducts = copy;  
  
    if (this.customerProducts.length === 1) {
      subTransaction.customerProduct = this.customerProducts[0].id;
    }

    this.subtransactionsForm.push(subtransactionForm);

    this.nextItemKey++;
  }

  removeSubTransaction(subtransactionForm, index) {
    this.removeFromSelectedProducts(subtransactionForm.customerProduct);
    this.reloadToAllCustomerProducts(subtransactionForm.customerProduct, index);

    for (let i = 0; i < this.subtransactionsForm.length; i++) {
      if (this.subtransactionsForm[i].key === subtransactionForm.key) {
        this.subtransactionsForm.splice(i, 1);
        break;
      }
    }
  }

  canAddCustomerProduct() {
    return this.customerProducts.length > 1;
  }

  canRemoveSubtransaction() {
    return this.subtransactionsForm.length > 1;
  }

  get totalAmount() {
    let totalAmount = numeral(0);

    this.subtransactionsForm.forEach((subtransactionForm) => {
      totalAmount = totalAmount.add(subtransactionForm.amount);
    });

    return totalAmount.format('0.00');
  }

  get totalAmountToBeSent() {
    let totalAmount = numeral(this.totalAmount);
    totalAmount = totalAmount.add(this.fee);

    return totalAmount.format('0.00');
  }

  toPayload() {
    let payload = {
      transaction: {
        email: this.email,
        paymentOptionType: this.paymentOptionType,
      }
    };

    payload['transaction']['paymentOption'] = this.paymentOption;
    payload['transaction']['customerFee'] = this.fee;

    let subTransactions = {};

    for (let subTransaction of this.subTransactions) {
      subTransactions[subTransaction.key] = {
        product: subTransaction.product,
        amount: subTransaction.amount
      };
    }

    return payload;
  }

  //============================================================================
  //  Code Below handles operations when a change in product selection occurs.
  //============================================================================
  onChangedCustomerProduct(index, newValue, oldValue) {
    this.selectedCustomerProducts.push(newValue);
    this.removeFromSelectedProducts(oldValue);
    this.removeFromSelection(newValue, index);
    this.reloadToAllCustomerProducts(oldValue, index);
  }

  removeFromSelection(newValue, index) {
    // Remove CustomerProduct with id matching the newValue within each SubTransactions
    for (let [sIndex, subTransaction] of this.subtransactionsForm.entries()) {
      // This condition will not remove the CustomerProduct from the owning SubTransaction.
      // The reason is that, when we tried to remove it, the ng-model will be affected does
      // will unselect the selection. Apparently, this is the same implementation on OLD AMS.
      if (index !== sIndex) {
        for (let [cIndex, customerProduct] of this.subtransactionsForm[sIndex].customerProducts.entries()) {
          if (customerProduct.id === newValue) {
            this.subtransactionsForm[sIndex].customerProducts.splice(cIndex, 1);
          }
        }
      }
    }
  }

  removeFromSelectedProducts(value) {
    if (value) {
      let oldValueIndex = this.selectedCustomerProducts.indexOf(value);
      this.selectedCustomerProducts.splice(oldValueIndex, 1);
    }
  }

  // Push CustomerProduct with id matching the oldValue (if oldValue is not null) within each SubTransactions
  reloadToAllCustomerProducts(oldValue, index) {
    if (oldValue) {
      let oldCustomerProduct = this.getCustomerProductById(oldValue);
      for (let [sIndex, subTransaction] of this.subtransactionsForm.entries()) {
        if (index !== sIndex) {
          subTransaction.customerProducts.push(oldCustomerProduct);
        }
      }
    }
  }

  getCustomerProductById(id) {
    return this.customerProducts.filter(customerProduct => customerProduct.id === id)[0];
  }
}



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit2/model/transaction-form.model.js